module.exports = __webpack_public_path__ + "static/img/编组 5备份.6e166d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz/编组 5备份.png
// module id = 9aR6
// module chunks = 1